import api from "./";
import { GetBlogResponse, GetPostsResponse, GetPostDetails, GetPageDetails, bloggerPageDetails } from "../types/bloggerServices";
export const getBlog = async (): Promise<GetBlogResponse> => {
    try {
      const response = await api.get<GetBlogResponse>(`/blogs/${process.env.REACT_APP_BLOGGER_BLOG_ID}?key=${process.env.REACT_APP_BLOGGER_API_KEY}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
};
export const getPosts = async (): Promise<GetPostsResponse> => {
    try {
      const response = await api.get<GetPostsResponse>(`/blogs/${process.env.REACT_APP_BLOGGER_BLOG_ID}/posts`,
        {
            params: {
                key: process.env.REACT_APP_BLOGGER_API_KEY,
                fields: "items(id,title,images,author,published)", // Request only needed fields
                fetchImages: true, // Ensure images are included
                maxResults: 20 // Add pagination
              }
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching posts:", error);
      throw error;
    }
};
export const getPost = async (postID: string): Promise<any> => {
    try {
      const response = await api.get<any>(`/blogs/${process.env.REACT_APP_BLOGGER_BLOG_ID}/posts/${postID}`,
        {
            params: {
                key: process.env.REACT_APP_BLOGGER_API_KEY,
                //fields: "items(title,content,author,published,images)", // Request only needed fields
                //fetchImages: true, // Ensure images are included
              }
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching posts:", error);
      throw error;
    }
};
export const getAboutPage = async (): Promise<bloggerPageDetails> => {
    try {
      const response = await api.get<bloggerPageDetails>(`/blogs/${process.env.REACT_APP_BLOGGER_BLOG_ID}/pages/${process.env.REACT_APP_BLOGGER_ABOUT_PAGE_ID}`,
        {
            params: {
                key: process.env.REACT_APP_BLOGGER_API_KEY,
                fields: "title,content", // Request only needed fields
                //fetchImages: true, // Ensure images are included
                maxResults: 20 // Add pagination
              }
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching posts:", error);
      throw error;
    }
};
export const getPage = async (pageID: string): Promise<bloggerPageDetails> => {
  try {
    const response = await api.get<bloggerPageDetails>(`/blogs/${process.env.REACT_APP_BLOGGER_BLOG_ID}/pages/${pageID}`,
      {
          params: {
              key: process.env.REACT_APP_BLOGGER_API_KEY,
              fields: "title,content", // Request only needed fields
              //fetchImages: true, // Ensure images are included
              maxResults: 20 // Add pagination
            }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching posts:", error);
    throw error;
  }
};